import type { ModalProduct, ModalVariants } from "./product-selection-modal";

export interface ProductVariantSelection {
  selectedProduct: ModalProduct;
  selectedVariants: ModalVariants[];
}

/**
 * Adds or removes a single variant. Dropping a product's last selected variant
 * removes the product too, so its checkbox and the entry stay in agreement.
 */
export function toggleVariantInSelection(
  selected: ProductVariantSelection[],
  product: ModalProduct,
  variant: ModalVariants,
  {
    exactlyOneVariant,
    isAtSelectionLimit,
  }: { exactlyOneVariant: boolean; isAtSelectionLimit: boolean },
): ProductVariantSelection[] {
  if (!selected.some((s) => s.selectedProduct.id === product.id)) {
    return isAtSelectionLimit
      ? selected
      : [
          ...selected,
          { selectedProduct: product, selectedVariants: [variant] },
        ];
  }

  return selected.flatMap((s) => {
    if (s.selectedProduct.id !== product.id) {
      return [s];
    }
    if (exactlyOneVariant) {
      return [{ ...s, selectedVariants: [variant] }];
    }
    if (
      s.selectedVariants.some(
        (v) => v.admin_graphql_api_id === variant.admin_graphql_api_id,
      )
    ) {
      const selectedVariants = s.selectedVariants.filter(
        (v) => v.admin_graphql_api_id !== variant.admin_graphql_api_id,
      );
      return selectedVariants.length > 0 ? [{ ...s, selectedVariants }] : [];
    }
    return isAtSelectionLimit
      ? [s]
      : [{ ...s, selectedVariants: [...s.selectedVariants, variant] }];
  });
}
